import React, { useEffect, useMemo, useState } from "react";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import { FiX, FiMenu } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import Scrollspy from 'react-scrollspy';

const SocialShare = [
    { label: "LinkedIn", Social: <FaLinkedinIn />, link: "https://www.linkedin.com/in/temefford" },
    { label: "GitHub", Social: <FaGithub />, link: "https://www.github.com/temefford" },
];

function HeaderAbs({ homeLink = "/", logo, color = "default-color" }) {
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isProjectsOpen, setIsProjectsOpen] = useState(false);
    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            setIsSticky(window.scrollY > 100);
        };

        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });

        return () => {
            window.removeEventListener("scroll", onScroll);
        };
    }, []);

    useEffect(() => {
        // Close any open menus when navigating.
        setIsMenuOpen(false);
        setIsProjectsOpen(false);
    }, [location.pathname, location.hash]);

    const logoUrl = useMemo(() => {
        const altText = "Theo Mefford";
        switch (logo) {
            case "light":
            case "dark":
            case "symbol-dark":
            case "symbol-light":
            default:
                return (
                    <img
                        src="/assets/images/portfolio/tmfavicon2.png"
                        alt={altText}
                        height="30px"
                    />
                );
        }
    }, [logo]);

    const headerClassName = `header-area header-style-two header--fixed ${color}${
        isSticky ? " sticky" : ""
    }`;
    const headerWrapperClassName = `header-wrapper${
        isMenuOpen ? " menu-open" : ""
    }`;

    return (
        <header className={headerClassName}>
            <div className={headerWrapperClassName}>
                <div className="header-left d-flex align-items-center">
                    <div className="logo">
                        <Link to={homeLink} onClick={() => setIsMenuOpen(false)}>
                            {logoUrl}
                        </Link>
                    </div>
                    <nav className="mainmenunav d-lg-block ml--50">
                        <Scrollspy
                            className="mainmenu"
                            items={["home", "about", "portfolio", "skills", "contact"]}
                            currentClassName="is-current"
                            offset={-200}
                        >
                            <li>
                                <a href="/#home" onClick={() => setIsMenuOpen(false)}>
                                    Home
                                </a>
                            </li>
                            <li>
                                <a href="/#about" onClick={() => setIsMenuOpen(false)}>
                                    About
                                </a>
                            </li>
                            <li className="has-droupdown">
                                <a
                                    href="/#portfolio"
                                    className={isProjectsOpen ? "open" : undefined}
                                    onClick={(e) => {
                                        // Mobile/tablet: tap toggles submenu. Desktop: behave like a normal anchor.
                                        if (window.innerWidth <= 991) {
                                            e.preventDefault();
                                            setIsProjectsOpen((prev) => !prev);
                                            return;
                                        }

                                        setIsMenuOpen(false);
                                        setIsProjectsOpen(false);
                                    }}
                                    aria-expanded={isProjectsOpen}
                                    aria-haspopup="true"
                                    aria-controls="projects-submenu"
                                >
                                    Projects
                                </a>
                                <ul
                                    id="projects-submenu"
                                    className={`submenu${isProjectsOpen ? " active" : ""}`}
                                >
                                    <li>
                                        <Link to="/enterprise-ai">Enterprise AI</Link>
                                    </li>
                                    <li>
                                        <Link to="/recent-work">Recent Work</Link>
                                    </li>
                                    <li>
                                        <Link to="/reference-architectures">Reference Architectures</Link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <a href="/#skills" onClick={() => setIsMenuOpen(false)}>
                                    Skills
                                </a>
                            </li>
                            <li>
                                <a href="/#contact" onClick={() => setIsMenuOpen(false)}>
                                    Contact
                                </a>
                            </li>
                        </Scrollspy>
                    </nav>
                </div>
                <div className="header-right">
                    <div className="social-share-inner">
                        <ul className="social-share rn-lg-size d-flex justify-content-center liststyle">
                            {SocialShare.map((val, i) => (
                                <li key={i}>
                                    <a
                                        href={val.link}
                                        aria-label={val.label}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {val.Social}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="header-btn">
                        <Link className="rn-button-style--2 rn-btn-dark" to="/contact">
                            Contact
                        </Link>
                    </div>
                    {/* Start Humberger Menu  */}
                    <div className="humberger-menu d-block d-lg-none pl--20">
                        <span
                            onClick={() => setIsMenuOpen((prev) => !prev)}
                            className="menutrigger text-white"
                        >
                            <FiMenu />
                        </span>
                    </div>
                    {/* End Humberger Menu  */}
                    <div className="close-menu d-block d-lg-none">
                        <span
                            onClick={() => setIsMenuOpen(false)}
                            className="closeTrigger"
                        >
                            <FiX />
                        </span>
                    </div>
                </div>
            </div>
        </header>
    );
}
export default HeaderAbs;
